<template>
    <div class="col-12 nopads">
        <top-bar :current-view="views.ORGANIZATION_CAMPAIGN_VIEW"/>
        <alert
                :show="alertVisible"
                :message="message"
                :variant="variant"
                @alertShown=alertShown
        />
        <div class="col-12 main-container">
            <div class="col-xl-10 content-container mx-auto">
                <transition name="fade">
                    <div class="col-12 nopads mt-6">
                        <b-container class="mb-3 pl-0 pr-0">
                          <b-col lg="12" class="no-gutters">
                            <div v-if="!editMode" class="round-btn top-right" @click.stop="addCampaign">
                              <font-awesome-icon icon="plus"/>
                            </div>
                            <h3>{{ $t("page.organization_campaigns") }}</h3>
                          </b-col>
                        </b-container>
                        <!-- Tabs -->
                        <b-container class="pl-0 pr-0" v-if="!editMode">
                            <b-row class="mb-4">
                                <div class="col-6 nopads fair-tab-container">
                                    <div
                                        class="col-12 nopads fair-tab align-bottom"
                                        v-bind:class="{ active_tab: activeTab===1}"
                                        @click.stop="setView(1)">
                                        <span class="tab-title">{{ $t('campaign.active')}}</span>
                                    </div>
                                </div>
                                <div class="col-6 nopads fair-tab-container align-bottom">
                                    <div
                                        class="col-12 nopads fair-tab align-bottom"
                                        v-bind:class="{ active_tab: activeTab===2}"
                                        @click.stop="setView(2)">
                                        <span class="tab-title">{{ $t('campaign.history')}}</span>
                                    </div>
                                </div>
                            </b-row>
                        </b-container>

                        <transition name="fade">
                            <campaigns
                                v-if="activeTab === 1"
                                ref="campaigns"
                                :active="true"
                                @onEditing="editStarted"
                                @onEditingDone="editDone"
                                :editable="true"
                                @alert="showAlert"/>
                        </transition>

                        <transition name="fade">
                            <campaigns
                                    v-if="activeTab === 2"
                                    ref="campaigns"
                                    :active="false"
                                    :closed="true"
                                    @onEditing="editStarted"
                                    @onEditingDone="editDone"
                                    :editable="false"
                                    @alert="showAlert"/>
                        </transition>
                    </div>
                </transition>
            </div>
            <footer-area />
        </div>
    </div>
</template>

<script>
    import {alertMixin} from "../mixins/AlertMixin";
    import Alert from "../components/Alert";
    import {views} from "../mixins/ViewMixin";
    import {userHelper} from "../mixins/UserMixin";
    import TopBar from "../components/TopBar";
    import Campaigns from "../components/campaign/Campaigns";
    import FooterArea from "@/components/FooterArea";

    export default {
        name: "user-campaign-view",
        mixins: [alertMixin, views, userHelper],
        components: {FooterArea, Campaigns, TopBar, Alert},
        data() {
            return {
                views,
                editMode: false,
                activeTab: 1
            }
        },
        methods: {
            addCampaign() {
                this.$refs['campaigns'].addCampaign()
            },
            setView(tab) {
                this.activeTab = tab
            },
            editStarted() {
                this.editMode = true
            },
            editDone() {
                this.editMode = false
            }
        }
    }
</script>

<style scoped>

</style>